// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__ECOXs","main":"style_main__1wUOW","button":"style_button__1VfyF","theme_selector_container":"style_theme_selector_container__gH44i"};